<template>
  <svg class="icon" :width="size" :height="size" viewBox="0 0 24 24" fill="none" stroke="currentColor"
    stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" v-html="iconPaths[name]"></svg>
</template>

<script setup lang="ts">
import { PropType } from 'vue'
import { iconPaths, IconName } from '@/component/ui/icons'

defineProps({
  name: { type: String as PropType<IconName>, required: true },
  size: { type: Number, default: 16 },
})
</script>

<style scoped>
.icon { flex-shrink: 0; display: inline-block; vertical-align: middle; }
</style>
